module.exports = __webpack_public_path__ + "static/prodinity_main_1-5f18910a9b45dafefcce12469cc8f6e9.png";